/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Prime.title') }} </h1>
        <ion-buttons v-if="!!infoUrl" slot="end">
          <ion-button @click="() => router.push(_getInfoUrl())">
            <ion-icon slot="icon-only" name="information-circle"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container ">

        <div class="ion-text-center" v-if="loading">
          <ion-spinner color="primary" name="crescent"></ion-spinner>
        </div>

        <div v-if="!loading" class="mc-prime-container">

          <div v-if="step == 1">
            <div class="d-flex ion-justify-content-center">
              <ion-text color="primary"><b>{{ $t('Prime.inscription')}}</b></ion-text>
            </div>
            <div class="d-flex ion-justify-content-center">
                <div class="dot active"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
            <br>
            <div style="line-height: 20px">
                {{ $t('Prime.inscription-desc', [$t('Prime.EEC-provider')])}}
                <ul style="padding-inline-start: 12px; line-height: 20px">
                  <li><div class="d-flex ion-justify-content-center ion-align-items-center"><div>{{ $t('Prime.informations-desc-3-start')}} <a @click="toastPhoneValidation();$router.push('update-profile')">{{ $t('Prime.informations-desc-3')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="user.phoneValidatedDate" name="checkmark"></ion-icon></div></li>
                  <li><div class="d-flex ion-justify-content-center ion-align-items-center"><div>{{ $t('Prime.informations-desc-4-start')}} <a @click="$router.push('update-profile')">{{ $t('Prime.informations-desc-4')}}</a> <ion-icon color="primary" v-on:click="$router.push('info-permis')"slot="icon-only" name="information-circle"></ion-icon>
                  </div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="user.drivingLicenceNumber" name="checkmark"></ion-icon></div></li>
                </ul>
            </div>
            <br>

            <div>
              {{$t('Prime.inscription-desc-2', [$t('Prime.EEC-platform')] )}}
            </div>
            <div v-if="!!infoUrl">
              <small><a style="color: black" :href="infoUrl">{{$t('Prime.inscription-show-more')}}</a></small>
            </div>
            <br>
            <!--
            <ion-item class="item-background">
              <ion-label position="stacked">{{$t('Prime.license')}} *</ion-label>
              <ion-input
                type="text"
                :placeholder="$t('Prime.license') + '*'"
                :value="driverLicense"
                @input="driverLicense = $event.target.value"
              >
              </ion-input>
            </ion-item>
            <br>
            -->


            <div class="signin">
              <div>
                {{$t('Prime.pre-signin', [$t('Prime.EEC-platform'), $t('Prime.EEC-provider')])}}
              </div>
              <div>
                {{$t('Prime.signin')}}
              </div>
              <ion-item class="item-background" lines="none" align-items-start>
                <ion-checkbox label-placement="end" style="font-size: 12px" :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" lines="none" :checked="checks[0]" @ionChange="switchCheck(0)"
                >
                  <span class="no-white-space"><b>{{ $t('Prime.signin-step1-title', [$t('Prime.EEC-provider')]) }}</b> {{ $t('Prime.signin-step1-desc') }}</span>
                </ion-checkbox>

              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox label-placement="end" style="font-size: 12px" :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[1]" @ionChange="switchCheck(1)">
                  <span class="no-white-space"><b>{{ $t('Prime.signin-step2-title', [$t('Prime.EEC-provider')]) }}</b> {{ $t('Prime.signin-step2-desc') }}</span>
                </ion-checkbox>
              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox label-placement="end" style="font-size: 12px" :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[2]" @ionChange="switchCheck(2)">
                  <span class="no-white-space"><b>{{ $t('Prime.signin-step3-title') }}</b> {{ $t('Prime.signin-step3-desc') }}</span>
                </ion-checkbox>
                </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox label-placement="end" style="font-size: 12px" :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[3]" @ionChange="switchCheck(3)">
                  <span class="no-white-space"><b>{{ $t('Prime.signin-step4-title') }}</b></span>
                </ion-checkbox>
               </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox label-placement="end" style="font-size: 12px" :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[4]" @ionChange="switchCheck(4)">
                  <span class="no-white-space"><b>{{ $t('Prime.signin-step5-title') }}</b> {{ $t('Prime.signin-step5-desc', [$t('Prime.EEC-provider')]) }}</span>
                </ion-checkbox>
                </ion-item>
            </div>

            <br>

            <div v-if="eecEligibility && (!eecEligibility.longDistanceEligibility || !eecEligibility.shortDistanceEligibility)">
              <ion-card class="" color="warning">
                <ion-card-content class="d-flex" >
                  <ion-icon style="min-height: 25px; min-width: 25px; margin-top: 3px; margin-right: 16px" name="alert"></ion-icon>
                  <div style="font-size: 14px;">
                    <div v-if="eecEligibility.longDistanceDrivingLicenceNumberDoublon == 1 || eecEligibility.shortDistanceDrivingLicenceNumberDoublon == 1">
                      Votre numéro de permis de conduire a déjà été utilisé pour faire une demande CEE. Vous ne pouvez pas refaire une demande.
                    </div>
                    <div v-if="eecEligibility.longDistancePhoneDoublon == 1 || eecEligibility.shortDistancePhoneDoublon == 1">
                      Votre numéro de téléphone a déjà été utilisé pour faire une demande CEE. Vous ne pouvez pas refaire une demande.
                    </div>
                    <div v-if="eecEligibility.longDistancePhoneDoublon == 0 && eecEligibility.shortDistancePhoneDoublon == 0 && eecEligibility.longDistanceDrivingLicenceNumberDoublon == 0 && eecEligibility.shortDistanceDrivingLicenceNumberDoublon == 0">
                      Vous avez déjà réalisé des trajets. Vous ne pouvez pas refaire une demande.
                    </div>
                  </div>
                </ion-card-content>
              </ion-card>
              <br>
            </div>

            <div v-if="eecEligibility && (eecEligibility.longDistanceJourneysNumber > 0 || eecEligibility.shortDistanceJourneysNumber > 0)">
              <ion-card class="" color="warning">
                <ion-card-content class="d-flex" >
                  <ion-icon style="min-height: 25px; min-width: 25px; margin-top: 3px; margin-right: 16px" name="alert"></ion-icon>
                  <div style="font-size: 14px;">
                    <div v-if="eecEligibility.longDistanceJourneysNumber > 0">
                      Vous avez déjà réalisé des trajets longue distance depuis le 1er janvier 2023.
                    </div>
                    <div v-if="eecEligibility.shortDistanceJourneysNumber > 0">
                      Vous avez déjà réalisé des trajets courte distance depuis le 1er janvier 2023.
                    </div>
                    <div v-if="!(eecEligibility.shortDistanceJourneysNumber > 0 && eecEligibility.shortDistanceJourneysNumber > 0)">
                      <b>Vous ne pourrez souscrire à l'offre correspondante.</b>
                    </div>
                    <div v-if="(eecEligibility.shortDistanceJourneysNumber > 0 && eecEligibility.shortDistanceJourneysNumber > 0)">
                      <b>Vous ne pouvez souscrire à aucune offre.</b>
                    </div>

                  </div>
                </ion-card-content>
              </ion-card>
              <br>
            </div>

            <div >
              <ion-button class='mc-big-button' color="success" expand="block" :disabled="isChecked() || (eecEligibility && ((eecEligibility.longDistanceJourneysNumber > 0 && eecEligibility.shortDistanceJourneysNumber > 0) || (!eecEligibility.longDistanceEligibility && !eecEligibility.shortDistanceEligibility)) )" @click="mobConnect()">
                {{ $t('Prime.mob-connect') }} <img style="margin-left: 10px; margin-bottom: 10px;" height="20px" src="/assets/mob.png"/>
              </ion-button>
                <div class="d-flex ion-justify-content-center ion-align-items-center">
                  <small>{{ $t('Prime.france-connect') }}</small>
                  <img style="margin-left: 10px" height="40px" src="/assets/france-connect.png"/>
                </div>
            </div>
            <div>
              <p style="color: grey; font-size: 10px;">{{ $t('Prime.EEC-provider-siren') }}</p>
            </div>





          </div>

          <div v-if="step == 2">
            <div class="d-flex ion-justify-content-center">
              <ion-text color="primary"><b>{{ $t('Prime.informations')}}</b></ion-text>
            </div>
            <div class="d-flex ion-justify-content-center">
              <div class="dot active"></div>
              <div class="dot active"></div>
              <div class="dot"></div>
            </div>
            <br>

            <div>
              {{ $t('Prime.informations-desc')}}
              <ul style="padding-inline-start: 12px;">
                <!-- todo iban status-->
                <li><div class="d-flex ion-justify-content-between ion-align-items-center"><div>{{ $t('Prime.informations-desc-1-start')}} <a @click="$router.push('bank-account')">{{ $t('Prime.informations-desc-1')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="bankAccount" name="checkmark"></ion-icon></div></li>
                <li><div class="d-flex ion-justify-content-between ion-align-items-center"><div>{{ $t('Prime.informations-desc-2-start')}} <a @click="$router.push('bank-account')">{{ $t('Prime.informations-desc-2')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="bankAccount && bankAccount.validationStatus == 1" name="checkmark"></ion-icon></div></li>
              </ul>
            </div>
          </div>

          <div v-if="step == 3">
            <div class="d-flex ion-justify-content-center">
              <ion-text color="primary"><b>{{ $t('Prime.suivi')}}</b></ion-text>
            </div>
            <div class="d-flex ion-justify-content-center" >
              <div class="dot active"></div>
              <div class="dot active"></div>
              <div class="dot active"></div>
            </div>
            <br>


            <ion-segment :value="tab" @ionChange="changeSegment($event)">
              <ion-segment-button value="short" v-if="isSdTabVisualized && hasShortDistance">
                <ion-label>{{$t('Prime.short-distance')}}</ion-label>
              </ion-segment-button>
              <ion-segment-button value="long" v-if="isLdTabVisualized && hasLongDistance">
                <ion-label>{{$t('Prime.long-distance')}}</ion-label>
              </ion-segment-button>
            </ion-segment>
            <br>

            <div v-if="tab == 'short' && isSdTabVisualized && hasShortDistance">
              <div v-if="ceeSubscription.shortDistanceSubscription && ceeSubscription.shortDistanceSubscription.version == 0">

                <div class="text-primary d-flex ion-margin-bottom" align-items-center=""><ion-icon name="cash" class="mr-5"></ion-icon> {{$t('Prime.short-price-0')}}</div>
                <!--<div v-if="(!!ceeSubscription && ceeSubscription.shortDistanceSubscription.journeys.length == 0)" class="mb-15" v-html="$t('Prime.prime-short-desc')"></div>-->
                <div class="eligibilityDate" v-if="ceeSubscription.shortDistanceSubscription.expirationDate"><ion-icon name="time" color="primary"></ion-icon> Vous avez jusqu’au {{ moment(ceeSubscription.shortDistanceSubscription.expirationDate ,'D MMMM YYYY') }} pour réaliser les trajets restants.</div>
                <div style="margin-bottom: 10px;"  v-if="!isPassed(ceeSubscription.shortDistanceSubscription.expirationDate)" >
                    <span class="mc-progress-bar-prime">
                      <b>{{(!!ceeSubscription && !!ceeSubscription.shortDistanceSubscription.journeys) ? Math.min( 10, ceeSubscription.shortDistanceSubscription.journeys.length) : 0 }} / 10 {{$t('Prime.short')}}</b>
                    </span>
                  <ion-progress-bar  color="primary" :value="((!!ceeSubscription && !!ceeSubscription.shortDistanceSubscription.journeys) ? Math.min(10, ceeSubscription.shortDistanceSubscription.journeys.length) : 0 ) / 10" ></ion-progress-bar>
                </div>
                <div v-if="isPassed(ceeSubscription.shortDistanceSubscription.expirationDate)">La période légale de 3 mois pour compléter vos trajets courte distance afin de profiter des 75€ de bonus est close. Mais vous pouvez continuer à faire des économies (et des rencontres!) en covoiturant.</div>
                <small>
                  <ul>
                    <li>{{$t("Prime.desc-1")}}</li>
                    <li>{{$t("Prime.desc-2")}}</li>
                    <li>{{$t("Prime.desc-3")}}</li>
                  </ul>
                </small>
              </div>

              <div v-if="ceeSubscription.shortDistanceSubscription && ceeSubscription.shortDistanceSubscription.version == 1">
                <div class="text-primary d-flex ion-margin-bottom" align-items-center=""><ion-icon name="cash" class="mr-5"></ion-icon> {{$t('Prime.short-price-1')}}</div>
                <div v-for="p in progressionShort">
                  <div>
                    <div class="ion-margin-top ion-margin-bottom d-flex ion-align-items-center">
                      <div style="width: 40px; margin-top: 4px" >
                        <ion-icon v-if="ceeSubscription.shortDistanceSubscription.progression && ceeSubscription.shortDistanceSubscription.progression[p.type] == true" color="success" name="checkmark-circle"></ion-icon>
                        <ion-icon v-if="ceeSubscription.shortDistanceSubscription.progression && ceeSubscription.shortDistanceSubscription.progression[p.type] == false" color="danger" name="close-circle"></ion-icon>
                      </div>
                      <div><b>{{ $t('Prime.progression-short.' + p.type + '.title')}}</b></div>
                    </div>
                    <div style="font-size: 15px" v-html="$t('Prime.progression-short.' + p.type + getDesc(ceeSubscription.shortDistanceSubscription, p.type))">

                    </div>
                    <div v-for="b in p.buttons.filter(item => item.type == ceeSubscription.shortDistanceSubscription.progression[p.type])">
                      <ion-button
                        class="mc-text-button mb-0"
                        color="primary"
                        expand="block"
                        fill="outline"
                        v-on:click="redirect(b.destination)"
                      >
                        {{ b.text }}
                      </ion-button>
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
            </div>

            <div  v-if="tab == 'long' && isLdTabVisualized && hasLongDistance">
              <div v-if="ceeSubscription.longDistanceSubscription && ceeSubscription.longDistanceSubscription.version == 0">
                <div class="text-primary d-flex ion-margin-bottom" align-items-center=""><ion-icon name="cash" class="mr-5"></ion-icon> {{$t('Prime.long-price-0')}}</div>
                <!--<div v-if="(!!ceeSubscription && ceeSubscription.longDistanceSubscription.journeys.length == 0)" class="mb-15" v-html="$t('Prime.prime-long-desc')"></div>-->
                <div class="eligibilityDate" v-if="ceeSubscription.longDistanceSubscription.expirationDate"><ion-icon name="time" color="primary"></ion-icon> Vous avez jusqu’au {{ moment(ceeSubscription.longDistanceSubscription.expirationDate, 'D MMMM YYYY') }} pour réaliser les trajets restants.</div>
                <div style="margin-bottom: 10px;" v-if="!isPassed(ceeSubscription.longDistanceSubscription.expirationDate)" >
                    <span class="mc-progress-bar-prime">
                      <b>{{(!!ceeSubscription && !!ceeSubscription.longDistanceSubscription.journeys) ? Math.min( 3, ceeSubscription.longDistanceSubscription.journeys.length) : 0 }} / 3 {{$t('Prime.long')}}</b>
                    </span>
                  <ion-progress-bar  color="primary" :value="((!!ceeSubscription && !!ceeSubscription.longDistanceSubscription.journeys) ? Math.min( 3, ceeSubscription.longDistanceSubscription.journeys.length) : 0 ) / 3" ></ion-progress-bar>
                </div>
                <div v-if="isPassed(ceeSubscription.longDistanceSubscription.expirationDate)">La période légale de 3 mois pour compléter vos trajets longue distance afin de profiter des 75€ de bonus est close. Mais vous pouvez continuer à faire des économies (et des rencontres!) en covoiturant.</div>

                <small>
                  <ul>
                    <li>{{$t("Prime.long-desc-1")}}</li>
                    <li>{{$t("Prime.desc-1")}}</li>
                    <li>{{$t("Prime.desc-2")}}</li>
                    <li>{{$t("Prime.desc-3")}}</li>
                  </ul>
                </small>
              </div>

              <!-- CEEStandardMobicoop -->
              <div v-if="ceeSubscription.longDistanceSubscription && ceeSubscription.longDistanceSubscription.version == 1">
                <div class="text-primary d-flex ion-margin-bottom" align-items-center=""><ion-icon name="cash" class="mr-5"></ion-icon> {{$t('Prime.long-price-1')}}</div>
                <div v-for="p in progressionLong">
                  <div>
                    <div class="ion-margin-top ion-margin-bottom d-flex ion-align-items-center">
                      <div style="width: 40px; margin-top: 4px" >
                        <ion-icon v-if="ceeSubscription.longDistanceSubscription.progression && ceeSubscription.longDistanceSubscription.progression[p.type] == true" color="success" name="checkmark-circle"></ion-icon>
                        <ion-icon v-if="ceeSubscription.longDistanceSubscription.progression && ceeSubscription.longDistanceSubscription.progression[p.type] == false" color="danger" name="close-circle"></ion-icon>
                      </div>
                      <div><b>{{ $t('Prime.progression-long.' + p.type + '.title')}}</b></div>
                    </div>
                    <div style="font-size: 15px" v-html="$t('Prime.progression-long.' + p.type + getDesc(ceeSubscription.longDistanceSubscription, p.type))">

                    </div>
                    <div v-for="b in p.buttons.filter(item => item.type == ceeSubscription.shortDistanceSubscription.progression[p.type])">
                      <ion-button
                        class="mc-text-button mb-0"
                        color="primary"
                        expand="block"
                        fill="outline"
                        v-on:click="redirect(b.destination)"
                      >
                        {{ b.text }}
                      </ion-button>
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
            </div>

            <div v-if="(ceeSubscription.shortDistanceSubscription && ceeSubscription.shortDistanceSubscription.version == 0) || (ceeSubscription.longDistanceSubscription && ceeSubscription.longDistanceSubscription.version == 0)" class="d-flex ion-justify-content-around">
              <div style="max-width: 40%">
                <div class="text-center" style="font-size: 30px"><b>{{ceeSubscription.nbPendingProofs}}</b></div>
                <div class="text-center" style="line-height: 16px"><small>{{$t("Prime.validation")}}</small></div>
              </div>
              <div style="max-width: 40%">
                <div class="text-center" style="font-size: 30px"><b>{{ceeSubscription.nbRejectedProofs}}</b></div>
                <div class="text-center" style="line-height: 16px"><small>{{$t("Prime.refused")}}</small></div>
              </div>
            </div>
            <br>
            <div v-if="(ceeSubscription.shortDistanceSubscription && ceeSubscription.shortDistanceSubscription.version == 0) || (ceeSubscription.longDistanceSubscription && ceeSubscription.longDistanceSubscription.version == 0)">
            <ion-button
              class="mc-big-button"
              color="primary"
              expand="block"
              fill="outline"
              @click="goToPostCarpool()"
              id="postCarpoolButton"
            >{{ $t('HOME.postCarpool') }}</ion-button>

            <ion-button
              v-if="isCapacitor && canSeeDynamics"
              class="mc-big-button"
              color="primary"
              expand="block"
              fill="outline"
              @click="goToDynamic()"
            >{{ $t('HOME.dynamic') }}</ion-button>
            </div>


          </div>

        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">

.mb-0 {
  margin-bottom: 0px !important;
}

.text-primary {
  color: var(--ion-color-primary);
}

.mc-prime-container {
  // background-color: rgba(var(--ion-color-primary-rgb), 0.13) !important;
  color: black !important;
  margin: -20px;
  padding: 20px;
  min-height: 100%;

}

.item-background {
  --background: transparent !important;
}

.dot {
  height: 8px;
  width: 8px;
  margin: 8px 3px;
  border-radius: 4px;
  background: var(--ion-color-medium);

  &.active {
    background: var(--ion-color-primary);
  }
}

.signin {
  font-size: 12px;

  .no-white-space {
    font-size: 12px;
  }

}

.mc-progress-bar-prime {
  position: absolute;
  width: calc(100% - 40px);
  z-index: 1;
  text-align: center;
  margin-top: 3px;
}

.eligibilityDate {
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;

  ion-icon {
    font-size: 14px;
    margin-right: 5px;
  }
}

</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import {required, minLength} from '@vuelidate/validators';
  import { address } from '../../Shared/Mixin/address.mixin';
  import Compressor from 'compressorjs';
  import {isPlatform} from "@ionic/core";
  import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';
  import moment from 'moment'
  import { useRouter } from 'vue-router';


  export default {
    name: 'prime',
    data () {
      return {
        step: 1,
        loading: false,
        driverLicense: '',
        isCapacitor : isPlatform(window.document.defaultView, "capacitor"),
        canSeeDynamics: JSON.parse(process.env.VUE_APP_CAN_SEE_DYNAMICS),
        infoUrl: process.env.VUE_APP_MOB_INFO_URL,
        ceeSubscription: null,
        eecEligibility: null,
        eecInstance: null,
        checks: [ false, false, false, false, false],
        tab: 'short',
        progressionShort: [],
        progressionLong: [],
        incentivesLD: JSON.parse(process.env.VUE_APP_EEC_LD),
        incentivesSD: JSON.parse(process.env.VUE_APP_EEC_SD),
        now: Date.now(),
        router: useRouter(),
      }
    },
    mixins: [toast, address],
    props : [],
    ionViewWillEnter() {
      this.mySubscriptions();
      this.myEligibility();
      this.getEecInstance();

      this.progressionShort = [
        {
          type: 'registrationFinalized',
          buttons: [
            {type: true, text: 'Publier une annonce', destination: 'post-carpool'},
          ]
        },
        {
          type: 'carpoolRegistered',
          buttons: [
            {type: null, text: 'Publier une annonce', destination: 'post-carpool'},
            {type: null, text: 'Certifier un covoiturage', destination: 'accepted-carpools'},
            {type: false, text: 'Publier une annonce', destination: 'post-carpool'},
            {type: false, text: 'Certifier un covoiturage', destination: 'accepted-carpools'},
            {type: false, text: 'Nous contacter', destination: 'carpool-contact'},
          ]
        },
        {
          type: 'carpoolValidated',
          buttons: []
        },
        {
          type: 'subscriptionBonified',
          buttons: [
            {type: false, text: 'Nous contacter', destination: 'carpool-contact'},
            {type: false, text: 'Publier une annonce', destination: 'post-carpool'},
          ]
        }
      ];

      this.progressionLong = [
        {
          type: 'registrationFinalized',
          buttons: [
            {type: true, text: 'Publier une annonce', destination: 'post-carpool'},
          ]
        },
        {
          type: 'firstCarpoolPublished',
          buttons: [
            {type: null, text: 'Publier une annonce', destination: 'post-carpool'},
          ]
        },
        {
          type: 'carpoolRegistered',
          buttons: [
            {type: null, text: 'Publier une annonce', destination: 'post-carpool'},
            {type: null, text: 'Certifier un covoiturage', destination: 'accepted-carpools'},
            {type: false, text: 'Publier une annonce', destination: 'post-carpool'},
            {type: false, text: 'Certifier un covoiturage', destination: 'accepted-carpools'},
            {type: false, text: 'Nous contacter', destination: 'carpool-contact'},
          ]
        },
        {
          type: 'carpoolPayedAndValidated',
          buttons: [

          ]
        },
        {
          type: 'subscriptionBonified',
          buttons: [
            {type: false, text: 'Nous contacter', destination: 'carpool-contact'},
            {type: false, text: 'Publier une annonce', destination: 'post-carpool'},
          ]
        }
      ]
    },
    validations: {
      driverLicense: {
        required,
        minLength: minLength(9)
      }
    },
    computed: {
      user: {
        get() {
          return this.$store.state.userStore.user;
        }
      },
      bankAccount() {
        return this.$store.state.paymentStore.bankAccount;
      },
      hasLongDistance() {
        return this.hasLongDistanceSubscriptionWithBonus || this.longDistanceSubscriptionAvailable;
      },
      hasLongDistanceSubscriptionWithBonus(){
        return !!this.ceeSubscription && !!this.ceeSubscription.longDistanceSubscription && this.ceeSubscription.longDistanceSubscription.version == 0;
      },
      longDistanceSubscriptionAvailable(){
        return this.incentivesLD.filter(incentiveVersion => new Date(incentiveVersion.minDate) <= Date.now() && Date.now() <= new Date(incentiveVersion.maxDate)).length > 0;
      },
      hasShortDistance() {
        return  this.hasShortDistanceSubscriptionWithBonus || this.shortDistanceSubscriptionAvailable;
      },
      hasShortDistanceSubscriptionWithBonus(){
        return !!this.ceeSubscription && !!this.ceeSubscription.shortDistanceSubscription && this.ceeSubscription.shortDistanceSubscription.version == 0;
      },
      shortDistanceSubscriptionAvailable(){
        return this.incentivesLD.filter(incentiveVersion => new Date(incentiveVersion.minDate) <= Date.now() && Date.now() <= new Date(incentiveVersion.maxDate)).length > 0;
      },
      isSdTabVisualized() {
        return this.eecInstance &&
        (
          !this.eecInstance.hasOwnProperty('ldProgressVisualization')
          || this.eecInstance.sdProgressVisualization
        );
      },
      isLdTabVisualized() {
        return this.eecInstance
          && (
            !this.eecInstance.hasOwnProperty('ldProgressVisualization')
            || this.eecInstance.ldProgressVisualization
        );
      }
    },
    methods: {
      switchCheck(index) {
        this.checks[index] = !this.checks[index]
        this.checks = Object.assign([], this.checks);
      },
      isChecked() {
        return this.checks.includes(false);
      },
      getBankAccount() {
        this.$store.dispatch('getBankAccount').then(res =>{
          this.bankAccount = res;
          if ((this.ceeSubscription.longDistanceSubscription || this.ceeSubscription.shortDistanceSubscription) && this.bankAccount.validationStatus == 1) {
            this.step = 3;
          }
          this.loading = false;
        }).catch(err => {
          this.loading = false;
        })
      },
      mobConnect() {
        // window.open('https://idp.preprod.moncomptemobilite.fr/auth/realms/mcm/protocol/openid-connect/auth?client_id=mobicoop_pub&redirect_uri=https://test.mobicoop.io/user/sso/eec-incentive/user/sso/login&state=mobConnect-test&response_mode=fragment&response_type=code&scope=openid&nonce=21a8befa-b65f-41c5-916b-29c9e8d70177', '_system');
        this.$store.dispatch('sso_connections', {eec: true}).then((res) => {
            if (res && res.length > 0) {
              let uri = res[0].uri;
              // uri = uri.replace('#', '%23').replace('/eec-incentive' , '/eec-incentive?mobicoop=true' ).replace('response_mode=query', 'response_mode=fragment' )  ;
              if (isPlatform(window.document.defaultView, "capacitor")) {
                this.openUrl(uri);
              } else {
                window.open(uri, '_system');
              }

            }
          }).catch((error) => {
            this.presentToast(this.$t("Commons.error"), "danger");
          })
      },
      openUrl(url) {
        InAppBrowser.create(url, '_system');
      },
      mySubscriptions() {
        this.loading = true;
        this.$store.dispatch('my_cee_subscriptions').then((res) => {
          this.ceeSubscription = res;
          if (this.ceeSubscription.longDistanceSubscription || this.ceeSubscription.shortDistanceSubscription) {
            this.step = 2;
            this.getBankAccount();
          } else {
            this.loading = false;
          }
        }).catch((error) => {
          this.loading = false;
          //this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
      myEligibility() {
        this.$store.dispatch('my_eec_eligibility').then((res) => {
          this.eecEligibility = res;
        }).catch((error) => {
          //this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
      goToPostCarpool() {
        this.$router.push({name: "post-carpool"});
      },
      goToDynamic() {
        this.$router.push({name: "dynamic"});
      },
      isPassed(date) {
        if (!date) {
          return false
        } else {
          return moment(date).isBefore(moment())
        }
      },
      changeSegment(event) {
        this.tab = event.detail.value;
      },
      getDesc(object, type) {
        if (object.progression) {
          switch (object.progression[type]) {
            case true :
              return '.desc-success';
            case false :
              return '.desc-error';
            default:
              return '.desc'
          }
        } else {
          return '.desc'
        }
      },
      redirect(destination) {
        this.$router.push({name: destination})
      },
      toastPhoneValidation() {
        this.presentToast(this.$t('Prime.phone-validation-info'), 'warning')
      },
      getEecInstance() {
      this.$store.dispatch('eec_instance').then((res) => {
        if (!res.sdProgressVisualization && res.ldProgressVisualization) {
          this.changeSegment({detail: {value: 'long'}})
        }
        this.eecInstance = res;
      }).catch(err => {

      })
    },
    _getInfoUrl() {
      return this.infoUrl.replace(/^\/#/g, "");
    }
    }
  }
</script>
